<template>
	<div class="content-box">
		<div class="row">
			<div class="col-md-12">
				<h3>代理商充值</h3>
			</div>
			<div class="col-md-12 mt-3">
				<form-operator
					:data-model-name="dataModelName"
					:rules="rules"
					:fields="editorFields"
					@submit="onSubmit"
					v-model="form"
				></form-operator>
			</div>
		</div>
	</div>
</template>

<script>
import FormOperator from "@/components/FormOperator.vue";

export default {
	data() {
		return {
			dataModelName: "Charging",
			form: {},
			editorFields: [
				{
					name: "customer",
					params: {
						type: "agent",
						tipShow: "balance",
						tipShowName: "当前余额"
					},
					col: 4,
					width: "100%"
				},
				{
					name: "type",
					col: 4
				},
				{
					name: "amount",
					col: 4
				},
				{
					name: "desc",
					col: 12,
					width: "100%",
					params: {
						rows: 5
					}
				},
				{
					name: "primary_img",
					col: 12
				}
			],
			rules: {
				userid: [
					{
						type: "object",
						required: true,
						fields: {
							_id: {
								type: "string",
								required: true,
								message: "必须选择有效用户"
							},
							name: {
								type: "string",
								required: true,
								message: "必须选择有效用户"
							}
						}
					}
				],
				type: [{ required: true, message: "请输入金额", trigger: "blur" }],
				amount: [
					{ required: true, message: "请输入金额", trigger: "blur" },
					{
						type: "number",
						min: 0.01,
						message: "金额必须大于0",
						trigger: "change"
					}
				]
			},
			loadings: {
				main: false
			}
		};
	},
	computed: {},
	created() {},
	mounted() {},
	methods: {
		onSubmit(data) {
			this.loadings.main = true;

			this.$axios
				.post("/customer/do_charge/", data)
				.then(json => {
					this.$message({
						type: "success",
						message: "充值成功!"
					});
					this.loadings.main = false;
					this.$emit("tab", "history");
					this.$router.push({
						name: "Customer-Agent",
						params: {
							tab: "history"
						}
					});
				})
				.catch(json => {
					this.loadings.main = false;
					if (this.err[json.data.field]) {
						this.err[json.data.field] = json.data.msg;
					}
					this.$message({
						message: json.data.msg,
						type: "error"
					});
				});
		}
	},
	watch: {},
	components: {
		FormOperator
	}
};
</script>
<style lang="scss" scoped>
</style>
